<template>
  <Modal v-model="visible"  :mask-closable="false"  :closable="false"
        width="40" class="custom-modal custom-height-modal" :style="{ top: '20px' }">
        <div slot="close"></div>
        <div slot="header"></div>
        <div slot="footer"></div>
        <LineProgress :oneProgress="oneProgress" :progressKey="progressKey"></LineProgress>
  </Modal>
</template>

<script>
import { mapGetters } from 'vuex'

import LineProgress from '@/components/LineProgress.vue';
export default {
  name: 'PageProgress',
  computed: {
    ...mapGetters(['getTranslation']),
    visible: {
            get() { return this.pageProgressModalVisible },
            set(val) { this.$emit('input', val) }
        },
  },
  components: {
    LineProgress
  },
  props: {
    oneProgress: Object,
    progressKey: Number,
    pageProgressModalVisible: Boolean,
  },
  methods: {
   
  }
}
</script>
<style>
  .custom-modal .ivu-modal-header {
    display: none;
}
.custom-modal .ivu-modal-footer {
    display: none;
}
.custom-modal .ivu-modal-close {
    display: none;
}


.custom-height-modal .ivu-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-height-modal .ivu-modal-content {
  max-height: 500px;  /* 固定高度 */
  height:auto;
  width:100%;
  margin: 0 auto;
}

.custom-height-modal .ivu-modal-body {
  height: calc(100% - 52px); /* 减去头部/底部高度 */
  overflow-y: auto;
}
</style>
<style scoped>
  
</style>